import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Settings, User, Crown, Gift, Lock, Trash2, ChevronLeft } from 'lucide-react'

export function Layout() {
  const navigate = useNavigate()
  const location = useLocation()
  
  const isHomePage = location.pathname === '/'
  
  const menuItems = [
    { path: '/', label: 'Profile', icon: User },
    { path: '/subscription', label: 'Subscription', icon: Crown },
    { path: '/invite-friends', label: 'Invite & Rewards', icon: Gift },
    { path: '/settings', label: 'Settings', icon: Settings },
    { path: '/change-password', label: 'Change Password', icon: Lock },
    { path: '/delete-account', label: 'Delete Account', icon: Trash2 },
  ]
  
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar - Desktop */}
      <aside className="hidden md:flex md:flex-col md:w-64 md:bg-white md:border-r md:border-gray-200">
        <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <div className="flex items-center flex-shrink-0 px-4 mb-8">
            <h1 className="text-2xl font-poppins font-bold text-gray-900">Account</h1>
          </div>
          <nav className="flex-1 px-2 space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon
              const isActive = location.pathname === item.path
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`
                    w-full group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                    ${isActive 
                      ? 'bg-primary-50 text-primary-600' 
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }
                  `}
                >
                  <Icon 
                    className={`mr-3 h-5 w-5 ${isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'}`}
                  />
                  {item.label}
                </button>
              )
            })}
          </nav>
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile header */}
        <header className="md:hidden bg-white border-b border-gray-200">
          <div className="flex items-center justify-between px-4 py-3">
            {!isHomePage && (
              <button
                onClick={() => navigate(-1)}
                className="flex items-center text-gray-700 hover:text-gray-900"
              >
                <ChevronLeft className="h-6 w-6" />
                <span className="ml-1 text-sm font-medium">Back</span>
              </button>
            )}
            <h1 className={`text-xl font-poppins font-semibold text-gray-900 ${isHomePage ? 'mx-auto' : 'ml-auto'}`}>
              Account
            </h1>
            {!isHomePage && <div className="w-16" />}
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200">
          <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
              <div className="text-sm text-gray-500">
                © 2025 ReferPal. All rights reserved.
              </div>
              <div className="flex space-x-6 text-sm">
                <a 
                  href="/privacy-policy" 
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Privacy Policy
                </a>
                <a 
                  href="mailto:support@referpal.com" 
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Contact
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}
